export default __webpack_public_path__ + "static/media/top-up-icon.a30f85ff.svg";